import { Home, Building2, ImageOff } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ListingImagePlaceholderProps {
  variant?: 'large' | 'small'
  className?: string
}

export function ListingImagePlaceholder({ variant = 'large', className }: ListingImagePlaceholderProps) {
  if (variant === 'small') {
    return (
      <div className={cn('w-full h-full bg-muted flex items-center justify-center', className)}>
        <ImageOff className="h-5 w-5 text-muted-foreground/40" />
      </div>
    )
  }

  return (
    <div className={cn('w-full h-full bg-gradient-to-br from-muted via-muted to-muted/80 flex flex-col items-center justify-center relative overflow-hidden', className)}>
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute top-4 left-4 rotate-12">
          <Home className="h-16 w-16" />
        </div>
        <div className="absolute bottom-8 right-6 -rotate-12">
          <Building2 className="h-20 w-20" />
        </div>
        <div className="absolute top-1/2 left-1/4 rotate-6">
          <Home className="h-12 w-12" />
        </div>
      </div>

      {/* Main content */}
      <div className="relative z-10 flex flex-col items-center gap-3">
        <div className="p-4 rounded-full bg-muted-foreground/5 border border-muted-foreground/10">
          <ImageOff className="h-8 w-8 text-muted-foreground/40" />
        </div>
        <div className="text-center">
          <p className="text-sm font-medium text-muted-foreground/60">No photos available</p>
          <p className="text-xs text-muted-foreground/40 mt-0.5">View original listing for details</p>
        </div>
      </div>
    </div>
  )
}
